import i18next from "i18next";
import { Compass, HeartCrack, Star } from "lucide-react";
import React from "react";

export interface InsightsTagProps {
  theme: "highlights" | "facts" | "next";
}

const InsightsTag: React.FC<InsightsTagProps> = ({ theme }) => {
  const { t } = i18next;

  const bgThemes = {
    highlights: "bg-mintGreenDark",
    facts: "bg-redLight",
    next: "bg-aquaLight",
  };

  const tagValue = {
    highlights: "highlights",
    facts: "brutal facts",
    next: t("next_steps"),
  };

  const icons = {
    highlights: <Star color="white" size={16} />,
    facts: <HeartCrack color="white" size={16} />,
    next: <Compass color="white" size={16} />,
  };

  return (
    <div
      className={`flex w-fit h-[24px] flex-row p-2 rounded-xl items-center gap-1 uppercase ${bgThemes[theme]}`}
    >
      <div>{icons[theme]}</div>
      <p className="text-[11px] text-whiteLight font-bold font-primary">
        {tagValue[theme]}
      </p>
    </div>
  );
};

export default InsightsTag;
